import { RegionMapObj } from "./consts";

export function regionMap(key: string) {
  // 机房映射
  return (RegionMapObj as any)[key] || key;
}

export function areaMap(key: string) {
  // 大区映射
  const map = {
    all: "全部区域", // Vue.$trans("all_regions"), // "全部区域",
    cn: "国内", // Vue.$trans("area_china"), // "国内",
    ap: "亚太", // Vue.$trans("area_asia"), // '亚太',
    eu: "欧洲", // Vue.$trans("area_europe"), // '欧洲'
  };
  return (map as any)[key] || key;
}
